import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHttpService } from 'src/app/Service/api.http.service';
import { APIEndPoints } from 'src/app/utils/api-endpoint';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireService {
  constructor(private _apiService: ApiHttpService) {}

  AddUser(body: any): Observable<any> {
    return this._apiService.post(`${APIEndPoints.User}/Add`, body).pipe();
  }
  getInteractionId() {
    return this._apiService.get(`${APIEndPoints.User}/Initialize`).pipe();
  }
  IsExistsEmail(interactionId, email) {
    return this._apiService
      .get(`${APIEndPoints.User}/ValidateEmail/${interactionId}/${email}`)
      .pipe();
  }
  CheckValidPromoCodeLink(promocode) {
    return this._apiService
      .get(`${APIEndPoints.User}/CheckValidPromoCodeLink/${promocode}`)
      .pipe();
  }
  validateEmailOTP(body) {
    return this._apiService
      .post(`${APIEndPoints.User}/Email/Validate`, body)
      .pipe();
  }
  validatePhoneOTP(body) {
    return this._apiService
      .post(`${APIEndPoints.User}/Phone/Validate`, body)
      .pipe();
  }

  validatePhone(interactionId, phone) {
    return this._apiService
      .get(`${APIEndPoints.User}/ValidatePhone/${interactionId}/${phone}`)
      .pipe();
  }
  getFeatures() {
    return this._apiService.get(`${APIEndPoints.User}/Features`).pipe();
  }
  
ValidateZip(data){
 return this._apiService.post(`${APIEndPoints.User}/ValidateZip`,data).pipe();
}
}
